import React, { useState, useEffect, useRef } from 'react';
import { formatMoneda, round } from '../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@material-ui/core';
import useTableScroll from '../useTableScrollcesar';
import { Table } from 'semantic-ui-react';
import { PinDropSharp } from '@material-ui/icons';
import { Mensaje, MensajeSiNo } from '../mensajes';
import axios from "axios";
import moment from 'moment';

const TablaRetencionesPago = (props) => {

    var op = require('../../../public/modulos/datos')
    let token = sessionStorage.getItem('jwtToken');

    const headCells = [
        { label: 'Código', textAlign: 'center' },
        { label: 'Descripción', textAlign: 'center' },
        { label: 'Base Imponible', textAlign: 'center' },
        { label: 'Alicuota', textAlign: 'center' },
        { label: 'Total Retenido', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead
    } = useTableScroll(headCells);

    const [mostrar2, setMostrar2] = useState(false);
    const [records, setRecords] = useState([]);
    const [datos, setDatos] = useState([]);
    const [tasacambio, setTasacambio] = useState(0.00);
    const [activate, setActivate] = useState(false);
    const [itemSelect, setItemSelect] = useState(null);
    const [opr, setOpr] = useState(0);
    const [idope, setIdope] = useState(null);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activ, setActiv] = useState(true);


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    useEffect(() => {

        if (props.idfact > 0) {
            seleccionarRetenciones(props.idfact);
        }

    }, [props.idfact]);

    const seleccionarRetenciones = (id) => {
        let endpoint = `${op.conexion}/api/retenciones/seleccionarretenciones?idfacturacompra=${id}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.length > 0) {
                        setRecords(response.data);
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    return (
        <div className=''>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

            <div className='col-md-12 row m-0 px-0'>
                <div className="col-md-12 px-0">
                    <TblContainer container={{ height: 180, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' }} >
                        <TblHead />
                        <TableBody className='overflow-hidden table-bordered' >
                            {
                                records && records.map((item, index) => (
                                    <TableRow key={index} style={{ padding: "0" }}>
                                        <TableCell className='align-baseBar bg-light' style={{ textAlign: "center", width: '80px' }} >{item.codigo}</TableCell>
                                        <TableCell className='align-baseline bg-light' style={{ textAlign: "center", width: '80px' }} >{item.descripcion}</TableCell>
                                        <TableCell className='align-baseline bg-light' style={{ textAlign: "right", width: '50px' }} >{props.val === 0 ? formatMoneda(item.baseimponible.toString().replace('.', ','), ',', '.', 2) : formatMoneda(round(item.baseimponible * props.tasa, 2).toString().replace('.', ','), ',', '.', 2)}</TableCell>
                                        <TableCell className='align-baseline bg-light' style={{ textAlign: "right", width: '50px' }} >{formatMoneda(item.alicuota.toString().replace('.', ','), ',', '.', 2) + " %"}</TableCell>
                                        <TableCell className='align-baseline bg-light' style={{ textAlign: "right", width: '50px' }} >{props.val === 0 ? formatMoneda(item.total.toString().replace('.', ','), ',', '.', 2) : formatMoneda(round(item.total * props.tasa, 2).toString().replace('.', ','), ',', '.', 2)}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </TblContainer>
                </div>
            </div>
        </div >
    );
}
export default TablaRetencionesPago;



// WEBPACK FOOTER //
// ./src/components/finanzas/tablaRetencionesDos.js